import { FciValueTypes } from '../constants'

export const tableHeaders = [
  'Date Received',
  'Date Due',
  'Pmt Day Variance',
  'Reference',
  'ACH',
  'Payment Type',
  'Total Pmt',
  'Total Interest Received',
  'Default Interest Received',
  'Note Interest Received',
  'Principal Received',
  'Accrued Lates Charges',
  'Late Charges Paid',
  'Reserve Pmt',
  'Reserve Restricted',
  'Escrow Pmt',
  'PPP Pmt',
  'Charges Prin Pmt',
  'Charges Int Pmt',
  'Broker Fees',
  'Lender Fees',
  'Other (Taxable)',
  'Other (Non-Taxable)',
  'Other Pmt',
  // 'Accrued Unpaid Interest',
  // 'Unpaid Note Interest',
  'Unpaid Default Interest',
  'Additional Information',
  // 'BWR Paid Service Fees',
  'Investor Asset Number',
]

export const tableBodyData: Record<string, FciValueTypes> = {
  dateReceived: FciValueTypes.Date,
  dateDue: FciValueTypes.Date,
  dayVariance: FciValueTypes.Text,
  reference: FciValueTypes.Text,
  isACH: FciValueTypes.Boolean,
  paymentType: FciValueTypes.Text,
  totalAmount: FciValueTypes.Number,
  toInterest: FciValueTypes.Number,
  defaultInterest: FciValueTypes.Number,
  noteInterest: FciValueTypes.Number,
  toPrincipal: FciValueTypes.Number,
  accruedLateCharges: FciValueTypes.Number,
  lateChargesPaid: FciValueTypes.Number,
  toReserve: FciValueTypes.Number,
  reserveRestricted: FciValueTypes.Number,
  toEscrow: FciValueTypes.Number,
  toPrepay: FciValueTypes.Number,
  toChargesPrincipal: FciValueTypes.Number,
  toChargesInterest: FciValueTypes.Number,
  toBrokerFee: FciValueTypes.Number,
  toLenderFee: FciValueTypes.Number,
  toOtherTaxable: FciValueTypes.Number,
  toOtherTaxFree: FciValueTypes.Number,
  toOtherPayments: FciValueTypes.Number,
  toUnpaidInterest: FciValueTypes.Number,
  notes: FciValueTypes.Text,
  investAssetNumber: FciValueTypes.Number,
}
